import React, { useMemo } from 'react';
import MultipleChoice from '@/pages/intelligence/components/MultipleChoice';

export default function CheckboxHeader(props) {
  const { selected = [], selectedAll = [], disabled, uniqueKey, onChange = () => console.log } = props;

  const isSelectedAll = useMemo(() => {
    if (selected?.length === selectedAll?.length) {
      return selected?.every((t) => selectedAll.filter((item) => item?.[uniqueKey] === t[uniqueKey]).length > 0);
    }
    return false;
  }, [selected, selectedAll]);

  return (
    <MultipleChoice
      value={isSelectedAll}
      indeterminate={isSelectedAll === false && selected?.length > 0}
      disabled={disabled}
      onChange={(v: boolean) => {
        if (selected?.length > 0) {
          // 取消全选
          onChange([], 'uncheck all');
        } else {
          /** 全选 */
          onChange(selectedAll, 'check all');
        }
      }}
    />
  );
}
